module.exports = __webpack_public_path__ + "src/taskpane/components/assets/MA Logo-no text.png";